import moment from "moment/moment";
import { FAILURE, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";
import { POST, PUT } from "../utils/const/http-const";

export async function obtenerListaSubTipoUsuarioWeb(combo = false) {
    try {
        let rows = [];
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/sub-tipo-usuario-web/obtener-lista-tipo-usuario-web/",
            {
                headers: getHeaders(),
                method: "POST",
                // body: JSON.stringify({data: 'hello'}),
            }
        ).then((res) => res.json());
        if (code === SUCCESS) {
            if (combo === true) {
                for (let i = 0; i < body.length; i++) {
                    const element = body[i];
                    let obj = {};
                    obj.value = element.id;
                    obj.label = element.descripcion;
                    rows.push(obj);
                }
            }
            if (combo === false) {
                for (let i = 0; i < body.length; i++) {
                    body[i].fechaProceso = moment(body[i].fechaProceso).format('DD/MM/YYYY HH:mm')
                    rows.push(body[i]);
                }
            }
        }
        return rows;
    } catch (err) {
        console.log("obtenerListaSubTipoUsuarioWeb err");
        console.log(err);
        return [];
    }
}

export async function crearSubTipoUsuarioWeb(obj) {
    try {
        let response = { error: true, id: 0 };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/sub-tipo-usuario-web/guardar-tipo-usuario-web/",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            response.error = false;
        }
        if (code === FAILURE) {
            response.error = true;
            response.message = message;
        }
        return response;
    } catch (err) {
        console.log("crearSubTipoUsuarioWeb err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function modificarSubTipoUsuarioWeb(obj) {
    try {
        let response = { error: true, id: 0 };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/sub-tipo-usuario-web/modificar-tipo-usuario-web/",
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            response.error = false;
        }
        if (code === FAILURE) {
            response.error = true;
            response.message = message;
        }
        return response;
    } catch (err) {
        console.log("modificarSubTipoUsuarioWeb err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function deshabilitarSubTipoUsuarioWeb(obj) {
    try {
        let result = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/sub-tipo-usuario-web/deshabilitar-tipo-usuario-web/",
            {
                headers: getHeaders(),
                method: "PUT",
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            result = true;
        }
        return result;
    } catch (err) {
        console.log("deshabilitarSubTipoUsuarioWeb err");
        console.log(err);
        return false;
    }
}
